var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.4991 6.93691C10.3841 6.93691 10.2908 7.03024 10.2916 7.14524C10.2916 7.26024 10.3849 7.35358 10.4999 7.35358C10.6149 7.35358 10.7083 7.26024 10.7083 7.14524C10.7083 7.03024 10.6149 6.93691 10.4991 6.93691",
    stroke: "#507889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 17.7703V17.7703C6.3575 17.7703 3 14.4128 3 10.2703V10.2703C3 6.12776 6.3575 2.77026 10.5 2.77026V2.77026C14.6425 2.77026 18 6.12776 18 10.2703V10.2703C18 14.4128 14.6425 17.7703 10.5 17.7703Z",
    stroke: "#507889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M10.4999 10.2703V14.4369",
    stroke: "#507889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e5e8c24acf975d4c1f3557eb6e62f8cd.svg";
export { ForwardRef as ReactComponent };